/**
 * @typedef {import("IZOX/__Typedef/common").lang} lang
 * @typedef {"no-reverse"} sentenceID
 */

class LangX {

  static __sentences = {
    "no-reverse": {
      EN: "Caution: This is irrevertable.",
      TC: "注意: 這操作不可逆轉"
    }
  }

  /**
   * 
   * @param {sentenceID} sentenceID 
   * @returns {lang}
   */
  static Get(sentenceID){
    return this.__sentences[sentenceID] ?? "";
  }

}

export default LangX;